import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { 
  Button, 
  Box, 
  Typography, 
  Divider,
  TextField,
  LinearProgress,
  Fade,
  Select,
  MenuItem,
  Tooltip,
  IconButton
} from '@mui/material';

import { Devices } from '../../../controllers';
import { Confirmation } from '../../utils';
import { CONST } from '../../../utils';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

export default function Main() {
    const nav = useNavigate();

    const [printers, SetPrinters] = React.useState([]);
    const [open, SetOpen] = React.useState(0);
    const [close, SetClose] = React.useState(0);

    React.useEffect(() => {
        LoadPrinterList();
        LoadPrinterMemory();
    },[]);

    const LoadPrinterList = async() => {
        const response = await Devices.GetBaggers();

        if(response === undefined){
            alert('Error fetching printer list. Please, reload page');
            return;
        }

        if(!response.success){
            alert('Error loading printer list. Please, reload page');
            console.log('Printer Error: ', response.error);
            return;
        }

        SetPrinters(response.result);
    }

    const LoadPrinterMemory = async() => {
        const openStore     = localStorage.getItem(CONST.STORAGE_KEYS.SHIPPING_OPEN_PRINTER);
        const closeStore    = localStorage.getItem(CONST.STORAGE_KEYS.SHIPPING_CLOSE_PRINTER);

        if(openStore !== undefined){
            SetOpen(Number(openStore));
        }

        if(closeStore !== undefined){
            SetClose(Number(closeStore));
        }
    }

    const SaveChanges = async() => {
        localStorage.setItem(CONST.STORAGE_KEYS.SHIPPING_OPEN_PRINTER, open);
        localStorage.setItem(CONST.STORAGE_KEYS.SHIPPING_CLOSE_PRINTER, close);
        alert('Configuration Updated');
    }

    return(
        <Box
            sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                padding:1
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Typography component="h1" variant="h5">
                    Configuration
                </Typography>
                
                <Button color='primary' onClick={()  => nav(-1)}> <KeyboardReturnIcon/> RETURN</Button>
            </Box>

            <Divider sx={{minWidth:'100%'}}></Divider>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    my:1
                    }}
            >
                <Typography variant='h6'>
                    Single Client Label Printer
                </Typography>
                <Select
                    sx={{
                        width:'100%'
                    }}
                    id="kind"
                    name='kind'
                    value={open}
                    onChange={(e) => SetOpen(e.target.value)}
                    autoFocus
                    size='small'
                >
                    <MenuItem key={0} value={0} selected>Select Printer</MenuItem>

                    {printers.map((value, i) => (
                        <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                    ))}

                </Select>

            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    my:1,
                    }}
            >
                <Typography variant='h6'>
                    Batch Client Label Printer
                </Typography>
                <Select
                    sx={{
                        width:'100%'
                    }}
                    id="kind"
                    name='kind'
                    value={close}
                    onChange={(e) => SetClose(e.target.value)}
                    autoFocus
                    size='small'
                >
                    <MenuItem key={0} value={0} selected>Select Printer</MenuItem>

                    {printers.map((value, i) => (
                        <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                    ))}

                </Select>

            </Box>

            <Divider sx={{minWidth:'100%', my:2}}></Divider>

            <Button variant='contained' fullWidth onClick={SaveChanges}> SAVE CHANGES </Button>
        </Box>
    );
}